'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var EventsConstants = {
    EVENT_PAGE_VIEW: 'pageview',
    EVENT_RESULT: 'result',
    EVENT_USER_ERROR: 'userError',
    EVENT_USER_WARNING: 'userWarning',
    EVENT_SERVICE_ERROR: 'serviceError',
    EVENT_SERVICE_WARNING: 'serviceWarning',
    EVENT_WARNING: 'warning',
    EVENT_ERROR: 'error'
};

exports.default = EventsConstants;


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/events/events.constants.js
// module id = 772
// module chunks = 0